query AvailableWorkgroupCurrencies($businessUnitId:UUID! $workgroupId: UUID) {
  availableWorkgroupCurrencies(
    businessUnitId:$businessUnitId
    workgroupId:$workgroupId
    orderBy: [ISO_CODE_ASC]) {
    nodes
     {
      id
      isoCode
      companySpotRate
      companyExchangeRate
      }
      }
  }